/**
 * Відповідність полів модуля «Зустрічі» поняттям довідника (підключається в features/knowledge/fieldTerms.ts).
 * Значок «?» з’являється, лише якщо поняття є в словнику сервера.
 */
export const MEETINGS_FIELD_TERMS: Readonly<Record<string, string>> = {
  'meetings.type.coordination': 'Координація',
  'meetings.type.oe_call': 'ОЕ',
  'meetings.report.coordination': 'Протокол координації',
  'meetings.link.matter': 'Відпрацювання',
};
